import { fetchRequest } from "@providers/conect";

const getAllSedesApi = async () => {
  try {
    const url = `sedes/all`;
    const response = await fetchRequest(url, {
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const viewSedesApi = async (data) => {
  try {
    const url = `sedes/view`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const getSedesByEmpresaApi = async (idEmp) => {
  try {
    const url = `sedes/empresa/${idEmp}`;
    const response = await fetchRequest(url, {
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const viewSedesEspeApi = async (data) => {
  try {
    const url = `sedes/view-sedes-especialidad`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Nuevo: consultar por oid_sede y empresa, devuelve un registro (o vacío)
const viewSedePorOidEmpresaApi = async (data) => {
  try {
    const url = `sedes/view-por-oid-empresa`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export {
  getAllSedesApi,
  viewSedesApi,
  getSedesByEmpresaApi,
  viewSedesEspeApi,
  viewSedePorOidEmpresaApi
};

// Actualizar una sede
const updateSedeApi = async (id, data) => {
  try {
    const url = `sedes/update/${id}`;
    const response = await fetchRequest(url, {
      method: "PUT",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const updateSedeSpecialtiesApi = async (id, specialties) => {
  try {
    const url = `sedes/update-specialties/${id}`;
    const response = await fetchRequest(url, {
      method: "PUT",
      body: { specialties }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { updateSedeApi, updateSedeSpecialtiesApi };

// Nuevo: sedes disponibles para programación extra (filtradas por especialidad y médico)
const getSedesDisponiblesProgramacionApi = async (data) => {
  try {
    const url = `sedes/disponibles-programacion`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { getSedesDisponiblesProgramacionApi };

const getSedesBySpecialtyApi = async (idEsp) => {
  try {
    const url = `sedes/by-specialty/${idEsp}`;
    const response = await fetchRequest(url, {
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { getSedesBySpecialtyApi };